export * from "./types.js";
export * from "./copy.js";
export {
  calculateFhssEligibility,
  calculateFhssBenefit,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { FhssRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of FHSS rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the right rules (e.g. the
 * lifetime cap was $30k before 1 Jul 2022 — a separate FY ruleset). */
export const FHSS_RULESETS: Record<string, FhssRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the FHSS ruleset for a financial year, or throw if unknown. */
export function fhssRulesFor(fy: FinancialYear): FhssRuleSet {
  const rules = FHSS_RULESETS[fy];
  if (!rules) {
    throw new Error(`no FHSS ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent FHSS ruleset — the default for live "this year" calcs. */
export const FHSS_CURRENT_FY: FinancialYear = "2025-26";
